import React from 'react';

export default function Caret() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" className="caret svg" width="16" height="16" viewBox="0 0 1792 1792"><path d="M1152 896q0 26-19 45l-448 448q-19 19-45 19t-45-19-19-45V448q0-26 19-45t45-19 45 19l448 448q19 19 19 45z" /></svg>
	);
}
